import React from 'react';
import './gift info.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message,Image } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment'
class giftInfo extends React.Component {
    state = {
        actionType:this.props.location.state.actionType?this.props.location.state.actionType==="EDIT"?"EDIT":"VIEW":"VIEW",
        id:this.props.location.state.data.id,
        name:this.props.location.state.data.name,
        status:this.props.location.state.data.status,
        createdAt:this.props.location.state.data.createdAt,
        bookedDate:this.props.location.state.data.bookedDate,
        owner:this.props.location.state.data.owner,
        description:this.props.location.state.data.description?this.props.location.state.data.description:allStrings.notExist,
        link:this.props.location.state.data.link?this.props.location.state.data.link:allStrings.notExist,
        price:this.props.location.state.data.price?this.props.location.state.data.price:allStrings.notExist,
        interest:this.props.location.state.data.interest?this.props.location.state.data.interest.name:allStrings.notExist,
        occasions:this.props.location.state.data.occasions?this.props.location.state.data.occasions:allStrings.notExist,
        bookedUser:this.props.location.state.data.bookedUser?this.props.location.state.data.bookedUser:null,
        gift:this.props.location.state.data,
        selectedFile: null,
        imgs:[],
        imgType:'url',
        imgName:''
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        if(this.props.location.state.data.img){
            this.setState({imgs:[{
                original:this.props.location.state.data.img,
                thumbnail:this.props.location.state.data.img,
            }]})
        }
        
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
       
    }
    updategift = () => {
        const {name,status,description,link,price,img,imgType} = this.state
        if(hasValue(name)&&hasValue(status) && img !=null){
            let l = message.loading('Wait..', 2.5)
            var data = new FormData()
            data.append('name',name)
            data.append('description',description)
            data.append('link',link)
            data.append('price',price)
            data.append('status',status)
            if(img != null && imgType === "data"){
                data.append('img',img)
            }
            
            console.log(Array.from(data))
            axios.put(`${BASE_END_POINT}gifts/${this.props.location.state.data.id}`,data,{
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization':`Bearer ${this.props.currentUser.token}`,
                    'Accept-Language':this.props.isRTL?'ar':'en'
                },
            })
            .then(response=>{
            console.log("gift UPDATED  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }
    }

    delete = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}gifts/${this.props.location.state.data.id}`,{
         headers: {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
         },
        })
        .then(response=>{
          console.log("gift DELETED")
          l.then(() => message.success(allStrings.done, 2.5) )
          this.props.history.goBack() 
        })
        .catch(error=>{
            console.log(error.response)
            l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
        })
    }
   

    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.updategift()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    fileChangedHandler = event => {
        
      this.setState({
        img: event.target.files[0],
        imgName: event.target.files[0].name,
        imgType:"data"
      })
     
      
    }
    removeFile = () => {
      this.setState({
          img:null,
          imgName:'',
          imgType:"url"
      });
    }
    imageSection = () =>{
          
        return(
          <MDBCol  xl ="4" lg = "4"  md="12" sm="12">
            <div className="infoCard" style={{marginTop:'80px'}}>
                <div className="StoreSlider">
                {/*<ImageGallery items={this.state.adsImgs} />*/}
                
                <div style={{height: '280px',overflow: 'hidden'}}>
                    <Image.PreviewGroup >
                    {this.state.imgs.map((val,i)=>
                        <Image placeholder={true} width="100%" height="100%" style={{display: i===0?"block":"none",borderRadius:'6px'}}   src={val.original} />
                    )}
                    </Image.PreviewGroup>
                </div>
                </div>
            </div>
            
        </MDBCol>
        )
    }
  
  render(){
    console.log(this.state.category)
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('GIFTS')) return <Redirect to='/Home' />
  return (
    <div className="App">
        <MDBContainer> 
            <MDBRow>  
                <MDBCol  xl={this.state.actionType==="VIEW"?"8":"12"} lg = {this.state.actionType==="VIEW"?"7":"12"} md="12" sm="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'#117183'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>star_outline</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                            <p>{this.state.actionType ==="VIEW"?allStrings.giftInfo:allStrings.edit}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    
                                    <div className="grey-text">
                                    {this.state.actionType ==="VIEW"&&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>#</label>
                                            <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.status}</label>
                                            <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.status==="AVAILABLE"?allStrings.availableGift:this.state.status==="BOOKED"?allStrings.booked:allStrings.given} type="text" id="form56" name="status" className="form-control" validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.name}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.name} type="text" id="form645" name="name" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.link} type="text" id="form645" name="link" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.price}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.price} type="text" id="form645" name="price" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.occasions}</label>
                                            {this.state.occasions.map((val, index) => (
                                                <span key={index} className="badge badge-primary mr-1 mb-1" style={{marginTop: "10px"}}>
                                                    {val.name}
                                                </span>
                                            ))}
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.interest}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.interest} type="text" id="form645" name="interest" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    {this.state.actionType === "VIEW"&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.createdAt}</label>
                                            <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={moment(this.state.createdAt).format('lll')} type="text" id="form645" name="createdAt" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    <MDBRow>
                                        <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="form70" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.description}</label>
                                            <br></br>
                                            <textarea disabled={this.state.actionType==="VIEW"?true:false} placeholder={allStrings.description} rows="3" style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} 
                                            defaultValue={this.state.description} type="text" id="form70" className="form-control" onChange={this.changeHandler} required validate name="description"/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                    </MDBRow>
                                    {this.state.actionType ==="VIEW"&&
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                        <MDBCol md="10" xs="10">
                                            <div class="md-form">
                                            <label htmlFor="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.owner}</label>
                                            <br></br>
                                            <div style={{textAlign:this.props.isRTL?'right':'left'}}>
                                            <p style={{borderBottom: '1px solid #dedede',width:'81%',padding:'10px',paddingBottom: '14px',fontSize: '16px',fontWeight: 400,color: '#000',display: 'inline-block'}}>
                                                {this.state.owner?this.state.owner.fullname:''}
                                            </p>
                                                <img style={{width: '50px',height: '50px',borderRadius: '50%',border:' 2px solid #117183'}} alt="" src={this.state.owner.img?this.state.owner.img:require('../../assets/images/profileicon.jpg')}/>
                                            </div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="2" xs="2">
                                        <br></br>
                                        <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                            <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                            onClick={()=>{this.props.history.push('userInfo',{data:this.state.owner}) }}>
                                              remove_red_eye
                                            </span>
                                            <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                              onClick={()=>{this.props.history.push('userInfo',{data:this.state.owner}) }}>
                                              {allStrings.show}
                                            </span> 
                                          </p>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.bookedUser&& this.state.actionType==="VIEW"&&
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                    <MDBCol md="10" xs="10">
                                        <div class="md-form">
                                        <label htmlFor="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.bookedUser}</label>
                                        <br></br>
                                        <div style={{textAlign:this.props.isRTL?'right':'left'}}>
                                        <p style={{borderBottom: '1px solid #dedede',width:'81%',padding:'10px',paddingBottom: '14px',fontSize: '16px',fontWeight: 400,color: '#000',display: 'inline-block'}}>
                                            {this.state.bookedUser?this.state.bookedUser.fullname:allStrings.notExist}
                                        </p>
                                            <img style={{width: '50px',height: '50px',borderRadius: '50%',border:' 2px solid #117183'}} alt="" src={this.state.bookedUser.img?this.state.bookedUser.img:require('../../assets/images/profileicon.jpg')}/>
                                        </div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="2" xs="2">
                                    <br></br>
                                    <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                        <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                        onClick={()=>{this.props.history.push('userInfo',{data:this.state.bookedUser}) }}>
                                          remove_red_eye
                                        </span>
                                        <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                          onClick={()=>{this.props.history.push('userInfo',{data:this.state.bookedUser}) }}>
                                          {allStrings.show}
                                        </span> 
                                      </p>
                                    </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.bookedDate &&this.state.actionType==="VIEW"&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.bookedDate}</label>
                                            <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={moment(this.state.bookedDate).format('lll')} type="text" id="form645" name="bookedDate" className="form-control" validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="EDIT"&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2"> 
                                                <input  key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                            </div>
                                            <div className="preview">
                                            {this.state.img&&
                                            <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                <img alt="" src={this.state.imgType==="data"?URL.createObjectURL(this.state.img):this.state.img}  className="previewImg2"/>
                                                <span className="imgName">{this.state.imgName}</span>
                                                <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                onClick={() => this.removeFile()}  ></MDBIcon>
                                            </div>
                                            }
                                            </div>
                                            
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                    {this.state.actionType==="EDIT"&&
                                        <MDBBtn
                                        style={{background:'#117183',color:'#fff'}}
                                        rounded
                                        color="#117183"
                                        type="submit"
                                        className="btn-block z-depth-1a"
                                        >
                                            <MDBIcon icon="edit" className="mr-2" />
                                            {allStrings.update}          
                                        </MDBBtn>
                                    }{this.state.actionType ==="VIEW"&&
                                        <MDBBtn onClick={()=>{this.delete()}} rounded color="danger" className="btn-block z-depth-1a">
                                            <MDBIcon icon="trash-alt" className="mr-2" />
                                            {allStrings.remove}
                                        </MDBBtn>
                                    }
                                    </div>
                                </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            {this.state.actionType==="VIEW"&&this.imageSection()}   
            </MDBRow>
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(giftInfo)
  );